import { Injectable } from '@angular/core';
import {AlertController, LoadingController, ModalController, ToastController} from '@ionic/angular';
import {LoadingFullScreenPage} from '../modals/loading-full-screen/loading-full-screen.page';
import {LanguageService} from './language.service';
import {Language} from '../interfaces/shared';

@Injectable({
  providedIn: 'root'
})
export class UtilService {

  constructor(
    public toastCtrl: ToastController,
    public alertCtrl: AlertController,
    private modalCtrl: ModalController,
    private language: LanguageService,
    private loadingCtrl: LoadingController
  ) { }

  async presentLoading(message: string = null) {
    if (!message) {
      message = this.language.currentLanguage === Language.arabic? 'من فضلك انتظر' : 'Loading';
    }
    const loading = await this.modalCtrl.create({
      component: LoadingFullScreenPage,
      cssClass: 'from-middle-modal',
      componentProps: {
        loadingText: this.language.currentLanguage === Language.arabic ? '...' + message: message + '...'
      }
    });
    await loading.present();
    return loading;
  }

  async presentTimedLoading(message: string, time: number) {
    const loading = await this.loadingCtrl.create({
      cssClass: 'loading-class',
      message: message + '...',
      duration: time
    });
    await loading.present();
  }

  async toast(msg, color, positon, cssClass?) {
    const toast = await this.toastCtrl.create({
      message: msg,
      duration: 3000, 
      color: color ? color : 'primary',
      position: positon,
      cssClass: cssClass
    });
    await toast.present();
  }

  async presentAlert(title: string, text: string) {
    const alert = await this.alertCtrl.create({
      header: title,
      message: text,
    });
    await alert.present();
  }
}
